import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function conteudos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@conteudos/REQUEST_SUCCESS': {
        draft.data = action.payload.contratos;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
